import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Chip from "@material-ui/core/Chip";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import VisibilityIcon from "@material-ui/icons/Visibility";

const FLAG_COLORS = {
  high_smoke_kill_profile: "#e53935",
  high_wallbang_kill_profile: "#ff6f00",
  low_headshot_high_kill_profile: "#6a1b9a",
};

const FLAG_LABELS = {
  high_smoke_kill_profile: "Smoke Kills",
  high_wallbang_kill_profile: "Wallbang Kills",
  low_headshot_high_kill_profile: "Low HS / High K",
};

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: theme.spacing(2),
  },
  headerCell: {
    fontWeight: 600,
    fontSize: "0.85rem",
    color: theme.palette.text.secondary,
  },
  chip: {
    margin: theme.spacing(0.25),
    fontSize: "0.75rem",
    height: 24,
  },
  steamId: {
    fontFamily: "monospace",
    fontSize: "0.85rem",
  },
  emptyState: {
    padding: theme.spacing(4),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
}));

function formatDate(dateStr) {
  if (!dateStr) return "—";
  const d = new Date(dateStr);
  return Number.isNaN(d.getTime()) ? "—" : d.toLocaleDateString();
}

export default function FlaggedPlayersTable({ players = [], onSelectPlayer }) {
  const classes = useStyles();

  if (players.length === 0) {
    return (
      <Paper className={classes.emptyState}>
        <Typography variant="body1">No flagged players found.</Typography>
        <Typography variant="body2" color="textSecondary">
          Players with behavioral anomalies detected by the anticheat system will appear here.
        </Typography>
      </Paper>
    );
  }

  return (
    <TableContainer component={Paper} className={classes.container}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell className={classes.headerCell}>Steam ID</TableCell>
            <TableCell className={classes.headerCell}>Flags</TableCell>
            <TableCell className={classes.headerCell} align="center">
              Observations
            </TableCell>
            <TableCell className={classes.headerCell} align="center">
              Matches
            </TableCell>
            <TableCell className={classes.headerCell}>Last Seen</TableCell>
            <TableCell className={classes.headerCell} align="center">
              Actions
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {players.map((player) => (
            <TableRow key={player._id} hover>
              <TableCell className={classes.steamId}>{player._id}</TableCell>
              <TableCell>
                {(player.flags || []).map((flag) => (
                  <Chip
                    key={flag}
                    label={FLAG_LABELS[flag] || flag}
                    size="small"
                    className={classes.chip}
                    style={{
                      backgroundColor: FLAG_COLORS[flag] || "#757575",
                      color: "#fff",
                    }}
                  />
                ))}
              </TableCell>
              <TableCell align="center">{player.observationCount}</TableCell>
              <TableCell align="center">{player.matchCount}</TableCell>
              <TableCell>{formatDate(player.lastSeen)}</TableCell>
              <TableCell align="center">
                <Tooltip title="Inspect player">
                  <IconButton
                    size="small"
                    onClick={() => onSelectPlayer(player._id)}
                  >
                    <VisibilityIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
